import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { QuickBooksConfig } from 'src/app/shared/models/third-party-software-config/quickbooks-config';
import { developmentConfig } from 'src/environments/merchant';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class QuickbooksService {
  initiateSaveQuickBooksEvent: EventEmitter<any> = new EventEmitter<any>();
  private baseRoute: string;
  private syncBaseRoute: string;
  private thirdPartyConfigAPIRoout: string;

  private qbImportSubject = new BehaviorSubject<boolean>(false);
  qbImport = this.qbImportSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService
  ) {
    this.baseRoute = environment.quickbooksAPIRoot;
    this.thirdPartyConfigAPIRoout = environment.thirdPartyConfigAPIRoout;
    this.syncBaseRoute = this.baseRoute.replace(
      'api/quickbooks',
      'quickbooks/api/quickbooks'
    );
  }

  startImport(isImporting: boolean) {
    this.qbImportSubject.next(isImporting);
  }

  loginToQuickbooks<T>(link: any): Observable<T> {
    return this.httpClient.post<T>(
      `${this.baseRoute}/login?redirectLink=${link}`,
      null
    );
  }

  disconnectToQuickbooks<T>(locationId: number): Observable<T> {
    return this.httpClient.post<T>(
      `${this.syncBaseRoute}/disconnect?locationId=${locationId}`,
      null
    );
  }

  syncData<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/syncdata`);
  }

  saveQuickbooksConfig<T>(quickbooksConfig: QuickBooksConfig): Observable<T> {
    return this.httpClient.post<T>(
      `${this.baseRoute}/insertqbconfig`,
      quickbooksConfig
    );
  }

  initiateSaveQuickbooksEventfunc(): void {
    this.initiateSaveQuickBooksEvent.emit('');
  }

  // Sync functions
  login<T>(locationId: number): Observable<T> {
    return this.httpClient.post<T>(
      `${this.syncBaseRoute}/login?LocationId=${locationId}`,
      null
    );
  }

  isSignedIn<T>(locationId?: number): Observable<T> {
    return this.httpClient.get<T>(
      `${this.syncBaseRoute}/active?locationId=${locationId}`
    );
  }

  setAuthToken<T>(params: any): Observable<T> {
    return this.httpClient.get<T>(
      `${this.syncBaseRoute}/getauthtokensasync?code=${params.code}&realmId=${
        params.realmId
      }&state=${params.state}&subdomain=${this.cookieService.get(
        'merchantSubdomain'
      )}`
    );
  }

  syncCustomers<T>(locationId: number): Observable<T> {
    return this.httpClient.get<T>(
      `${this.syncBaseRoute}/customer/pullqbcustomertocashjar?locationId=${locationId}`
    );
  }

  syncItems<T>(userId: number, locationId: number): Observable<T> {
    return this.httpClient.post<T>(
      `${this.syncBaseRoute}/item/pullqbitemstocashjar?userId=${userId}&locationId=${locationId}`,
      null
    );
  }

  saveSendingOptions<T>(locationId: number, option: number): Observable<T> {
    return this.httpClient.post<T>(
      `${this.thirdPartyConfigAPIRoout}/updateqbsendoption?locationId=${locationId}&qbSendOption=${option}`,
      null
    );
  }

  syncInvoices<T>(locationId: number): Observable<T> {
    let merchantName = '';
    let subDomain = window.location.origin.split('.')[0]; //WHERE [0] IS http(s)://subdomainName

    if (
      subDomain.indexOf('http://localhost') > -1 ||
      subDomain.indexOf('http://127') > -1
    ) {
      merchantName = developmentConfig.merchant;
    } else {
      merchantName = subDomain.replace(/^https:/, '').replace('//', '');
      merchantName = merchantName.replace(/^http:/, '').replace('//', '');
    }

    return this.httpClient.post<T>(
      `${this.syncBaseRoute}/invoice/pullqbinvoicestocashjar?locationId=${locationId}&businessCode=${merchantName}`,
      null
    );
  }
}
